import { transform } from './utils'
import departures from './departures'
import { nasdaq, nasdaqById } from './nasdaq'
import nasdaqChartLatest, {
  nasdaqChartHistory,
  nasdaqShareInfo,
} from './nasdaqChart'

const resolvers = {
  Query: {
    departures,
    nasdaq,
    nasdaqById,
    nasdaqChartLatest,
    nasdaqChartHistory,
    nasdaqShareInfo,
  },
}

export default transform(resolvers)
